export default {
	namespaced: true,

	state: {
		appWidget: null
	},

	mutations: {
		set(state, data) {
			state.appWidget = data.appWidget;
		}
	},

	getters: {
		getAppWidget(state) {
			return state.appWidget;
		}
	},

	actions: {
		async add(context, options) {
			context.commit('set', options);
		}
	}
};